import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { CloseCircleOutlined, CloseOutlined } from "@ant-design/icons";
import "./RemovedFromWatchlistAlert.css";

export default function RemovedFromWatchlistAlert({
  open,
  onClose,
  vehicleName,
}) {
  useEffect(() => {
    if (!open) return;
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [open, onClose]);

  if (!open) return null;

  const content = (
    <div
      className="watchlist-remove-alert-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="watchlist-remove-alert-title"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="watchlist-remove-alert">
        <button
          type="button"
          className="watchlist-remove-alert-close"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseOutlined />
        </button>

        <div className="watchlist-remove-alert-header">
          <div className="watchlist-remove-alert-icon-wrap">
            <CloseCircleOutlined className="watchlist-remove-alert-icon" />
          </div>
          <div className="watchlist-remove-alert-titles">
            <h2 id="watchlist-remove-alert-title" className="watchlist-remove-alert-title">
              Removed from Watchlist
            </h2>
            {vehicleName && (
              <p className="watchlist-remove-alert-subtitle">{vehicleName}</p>
            )}
          </div>
        </div>

        {vehicleName && (
          <p className="watchlist-remove-alert-message">
            {vehicleName} is no longer being tracked.
          </p>
        )}
      </div>
    </div>
  );

  return createPortal(content, document.body);
}
